import { defineOpenSNSocialDefinition, type OpenSNSocialDefinition } from "opensn/schema";
import definition from "./social-definition.json";

export const socialDefinition = defineOpenSNSocialDefinition(definition as OpenSNSocialDefinition);
